// Helper function to get the display text from a rendered value
export const getDisplayText = renderedValue => {
  if (renderedValue == null) return "";
  if (typeof renderedValue === "string") return renderedValue;
  if (typeof renderedValue === "number" || typeof renderedValue === "boolean") return String(renderedValue);

  if (renderedValue && typeof renderedValue === "object" && renderedValue.props) {
    const { children } = renderedValue.props;
    if (children == null) return "";
    if (typeof children === "string") return children;
    if (typeof children === "number" || typeof children === "boolean") return String(children);
    if (Array.isArray(children)) {
      return children.map(child => getDisplayText(child)).join("");
    }
    return getDisplayText(children);
  }

  return String(renderedValue);
};

// Checks if a row matches the filter criteria for a specific column
export const matchesColumnFilter = (col, row, filters) => {
  if (col.filterable === false || !filters[col.key]) return true;

  const filterText =
    typeof filters[col.key] === "string" ? filters[col.key].trim() : String(filters[col.key] ?? "").trim();
  if (!filterText) return true;

  const rawValue = row?.[col.key];

  // Special handling for boolean raw values
  if (typeof rawValue === "boolean") {
    const lower = filterText.toLowerCase();
    // Check if filter text matches the rendered display text first
    if (col.render) {
      const rendered = col.render(rawValue, row);
      const displayValue = getDisplayText(rendered);
      if (displayValue.toLowerCase().includes(lower)) return true;
    }
    // Also support common boolean aliases
    const trueAliases = ["true", "yes", "1", "connected", "enabled", "ready"];
    const falseAliases = ["false", "no", "0", "disconnected", "disabled", "not ready"];
    const matchesTrue = trueAliases.some(a => a.includes(lower));
    const matchesFalse = falseAliases.some(a => a.includes(lower));
    if (matchesTrue && !matchesFalse) return rawValue === true;
    if (matchesFalse && !matchesTrue) return rawValue === false;
    return matchesTrue || matchesFalse;
  }

  let displayValue;
  if (col.render) {
    const rendered = col.render(rawValue, row);
    displayValue = getDisplayText(rendered);
  } else {
    displayValue = String(rawValue ?? "");
  }

  return displayValue.toLowerCase().includes(filterText.toLowerCase());
};
